<template>
  <van-popup
    v-model:show="popShow"
    round
    :z-index="3000"
    position="bottom"
    :style="{ maxHeight: '70vh', overflow: 'hidden' }"
    :duration="popShow ? '0.2' : '0.2'"
  >
    <div class="pay_course_pop">
      <div class="pay_head">
        <div class="pay_title">{{ categoryName || $t('all') }}</div>
        <div class="close_box" @click.stop="closePopup">
          <i class="iconfont icon-icon_wode_wodepeixun_guanbi pay_close"></i>
        </div>
      </div>
      <div class="container">
        <div class="pay-course">
          <div class="pay-m">
            <i class="iconfont icon-wodedingdan icon_c"></i>
          </div>
          <div class="pay-desc" @click="goShopIndex">
            <div>{{ $t('more_course_to_exchange') }}</div>
            <i class="iconfont icon-icon_tiaozhuan pay-jump"></i>
          </div>
        </div>
        <div class="course_list">
          <div class="course_item" v-for="item in goodsInfo" :key="item.id" @click="goShopDetail(item.id)">
            <div class="course_cover">
              <!-- <div class="course_new_hot">热门课程</div> -->
              <div class="course_type_name" v-if="getSpu(item.spuType)">{{ getSpu(item.spuType) }}</div>
              <img class="course_img" :src="item.coverImgUrl || ''" />
            </div>
            <div class="c_info">
              <div class="course_title">{{ item.spuName || '' }}</div>
              <div class="course_bom">
                <div class="cb_left" v-if="item.isCashPay === 1 && item.defaultPayType === 1">
                  <div class="cb_unit">￥</div>
                  <div class="cb_price2">{{ item.price || 0 }}</div>
                </div>
                <div class="cb_left" v-if="item.isIntegralPay === 1 && item.defaultPayType === 2">
                  <div class="cb_value">{{ item.integral || 0 }}</div>
                  <div class="cb_price">{{ $t('shop_integral') }}</div>
                </div>
                <div class="cb_left" v-if="item.isCombinationPay === 1 && item.defaultPayType === 3">
                  <div class="cb_value">{{ item.combinationIntegral || 0 }}</div>
                  <div class="cb_price">{{ $t('shop_integral') }}+¥{{ item.combinationPrice || 0 }}</div>
                </div>
              </div>
              <div class="cb_right">{{ item.buyTotal || 0 }}{{ $t('shop_bought_count') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onDeactivated } from 'vue'
import { useThemeColorWithAlpha, useThemeColor, useThemeId } from '@/utils/theme'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'

interface GoodsItem {
  id: string
  spuType: number
  coverImgUrl?: string
  spuName?: string
  isCashPay: number
  defaultPayType: number
  price?: number
  isIntegralPay: number
  integral?: number
  isCombinationPay: number
  combinationIntegral?: number
  combinationPrice?: number
  buyTotal?: number
}

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  categoryName: {
    type: String,
    default: ''
  },
  goodsInfo: {
    type: Array as () => GoodsItem[],
    default: () => []
  }
})

const { t } = useI18n()
const router = useRouter()
const themeColor = useThemeColor()
const themeType = useThemeId()
const themeColorWithAlpha = useThemeColorWithAlpha(0.2)
const themeLinearColorWithAlpha = useThemeColorWithAlpha(0.3)
const emits = defineEmits(['update:show', 'changeShow'])
const popShow = computed({
  get: () => props.show,
  set: (v: boolean) => {
    emits('update:show', v)
    emits('changeShow', v) // 兼容父级若仍监听 change-show
  }
})
const closePopup = () => {
  popShow.value = false
}
const goShopIndex = () => {
  popShow.value = false
  router.push({ path: '/shopIndex' })
}
const goShopDetail = (id: string) => {
  popShow.value = false
  router.push({ path: '/shopDetail', query: { id } })
}
onDeactivated(() => {
  popShow.value = false
})
onBeforeUnmount(() => {
  popShow.value = false
})
const getSpu = computed(() => (spuType: number) => {
  if (spuType === 1) return t('shop_course')
  if (spuType === 2) return t('shop_entity')
  if (spuType === 3) return t('shop_service')
  return ''
})

const payThemeTextColor = computed(() => {
  let color = ''
  switch (themeType.value) {
    case 'red':
      color = '#850000'
      break
    case 'blue':
      color = '#003685'
      break
    case 'orange':
      color = '#855500'
      break
  }
  return color
})
</script>

<style scoped lang="less">
@imgWidth: calc((100vw - 8px - 32px) / 2);
@imgHeight: calc(@imgWidth * 0.75);
.pay_course_pop {
  width: 100%;
  height: 70vh;
  background: #f3f3f3;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .pay_head {
    width: 100%;
    height: 57px;
    display: flex;
    align-items: center;
    padding: 0 16px;
    border-bottom: 1px solid #e9e9e9;
  }
  .pay_title {
    color: #171921;
    font-size: 16px;
    font-weight: bold;
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }
  .close_box {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .pay_close {
    font-size: 12px;
    color: #b7b7b7;
    padding-left: 6px;
  }
  .container {
    width: 100%;
    overflow: scroll;
    flex: 1;
    height: calc(70vh - 57px);
    padding: 0 16px;
  }
  .pay-course {
    width: 100%;
    height: 30px;
    border-radius: 6px;
    overflow: hidden;
    display: flex;
    align-items: center;
    margin: 12px 0;
  }
  .pay-m {
    width: 30px;
    height: 100%;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    background: linear-gradient(to bottom right, v-bind(themeLinearColorWithAlpha), v-bind(themeColor));
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .icon_c {
    font-size: 13px;
    color: #fff;
  }
  .pay-desc {
    flex: 1;
    height: 30px;
    background: v-bind(themeColorWithAlpha);
    color: v-bind(payThemeTextColor);
    font-size: 13px;
    display: flex;
    align-items: center;
    text-indent: 8px;
  }
  .pay-jump {
    font-size: 13px;
    color: v-bind(payThemeTextColor);
    margin-left: -4px;
  }
  .course_list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .course_item {
    width: @imgWidth;
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
    margin-bottom: 8px;
  }
  .course_cover {
    width: 100%;
    position: relative;
    height: 167px;
  }
  .course_new_hot {
    position: absolute;
    left: 8px;
    top: 8px;
    z-index: 1;
    color: #fff;
    font-size: 12px;
    padding: 4px 6px;
    border-radius: 3px;
    background: linear-gradient(270deg, v-bind(themeColor), v-bind(themeLinearColorWithAlpha));
  }
  .course_type_name {
    position: absolute;
    right: 8px;
    bottom: 8px;
    z-index: 1;
    color: #fff;
    font-size: 12px;
    padding: 4px 6px;
    border-radius: 3px;
    background: #000;
  }
  .course_img {
    width: 100%;
    height: @imgHeight;
  }
  .c_info {
    padding: 6px;
  }
  .course_title {
    font-size: 14px;
    color: #171921;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }
  .course_bom {
    margin-top: 5px;
    display: flex;
    align-items: flex-end;
  }
  .cb_left {
    display: flex;
    align-items: flex-end;
  }
  .cb_value {
    font-size: 18px;
    color: v-bind(themeColor);
    margin-bottom: -2px;
  }
  .cb_price {
    font-size: 12px;
    color: v-bind(themeColor);
    transform: scale(0.84);
    transform-origin: left center;
    margin-left: 1px;
  }
  .cb_unit {
    font-size: 12px;
    color: v-bind(themeColor);
  }
  .cb_price2 {
    font-size: 18px;
    color: v-bind(themeColor);
    margin-bottom: -3px;
  }
  .cb_right {
    color: #999999;
    font-size: 12px;
    padding-top: 10px;
  }
}
</style>
